export const FIREBASE_CONFIG = {
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
};

// Backend callable/HTTP functions base (configurable per environment)
// Prefer setting REACT_APP_FUNCTIONS_BASE to your deployed root (e.g. https://us-central1-yourproj.cloudfunctions.net)
// Then compose endpoint paths inside services.
export const FUNCTIONS_BASE =
  process.env.REACT_APP_FUNCTIONS_BASE ||
  'https://us-central1-luminx-iq.cloudfunctions.net';

// Firebase Functions callable config
export const FUNCTIONS_REGION =
  process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1';
export const FUNCTIONS_CUSTOM_DOMAIN =
  process.env.REACT_APP_FUNCTIONS_CUSTOM_DOMAIN || undefined;
export const API_VERSION = 'v1';
export const BASE_API_URL = `${FUNCTIONS_BASE}/api/${API_VERSION}`;
export const AI_API_KEY = process.env.REACT_APP_GEMENI_API_KEY;
